export enum DECK_PAGE_MODE {
  EDIT = 'edit',
  PREVIEW = 'preview',
  EXPORT = 'export',
}

export interface IDeckPageLayout {
  mode?: DECK_PAGE_MODE
}
